import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { AppContext } from "@/contexts/AppContext";
import { getHttpResponse } from "@/api/helper";
/** @typedef {import("@/types/UserInfo").UserInfo} UserInfo */
const useGetUserInfoQuery = () => {
    const { userId, token, providerId } = useContext(AppContext);
    /** @type {()=>Promise<import("axios").AxiosResponse<UserInfo,any>>} */
    const fetchFn = async () => {
        var res = await getHttpResponse(
            `/user-configuration-service/provider/${providerId}/users/${userId}`,
            token,
            userId,
        );
        if (res.status === 200) {
            const resData = res.data;
            window.clarity?.("identify", String(resData.id));
            window.clarity?.("set", "userId", String(resData.id));
            window.clarity?.("set", "fripickid", String(resData.fripickId));
            window.clarity?.("set", "userName", `${resData.name} ${resData.lastName}`);
        }
        return res;
    };

    return useQuery({
        queryKey: ["userInfo", userId],
        staleTime: 300,
        refetchOnWindowFocus: false,
        queryFn: fetchFn,
    });
};

export default useGetUserInfoQuery;
